import { useOpts } from '../context';
var useShowingExitConfirmation = function () {
    // TODO: this should be moved to the redux state
    var opts = useOpts();
    var showingExitConfirmation = opts.showingExitConfirmation, setShowingExitConfirmation = opts.setShowingExitConfirmation;
    return {
        // Set default values as opts fields have optional types, even though these
        // will always exist in practice.
        showingExitConfirmation: showingExitConfirmation !== null && showingExitConfirmation !== void 0 ? showingExitConfirmation : false,
        setShowingExitConfirmation: setShowingExitConfirmation !== null && setShowingExitConfirmation !== void 0 ? setShowingExitConfirmation : (function () { }),
    };
};
export default useShowingExitConfirmation;
